import { RadioButton } from "primereact/radiobutton";
import React from "react";

const UserCards = ({cards, handleSelectCard, loading}) => {

  const cardBrandIcon = {
    visa: "fa-brands fa-cc-visa",
    mastercard: "fa-brands fa-cc-mastercard",
    amex: "fa-brands fa-cc-amex",
    discover: "fa-brands fa-cc-discover",
    diners: "fa-brands fa-cc-diners-club",
    jcb: "fa-brands fa-cc-jcb",
    maestro: "fa-brands fa-cc-maestro",
    unknown: "fa-regular fa-credit-card",
  };

  const getCardBrandByDigits = (firstSix, lastFour) => {
    const cardPatterns = {
      visa: /^4/,
      mastercard: /^5[1-5]/,
      amex: /^3[47]/,
      discover: /^6(?:011|5)/,
      diners: /^3(?:0[0-5]|[68])/,
      jcb: /^(?:2131|1800|35)/,
      maestro: /^5[06789]|6/,
    };

    for (let brand in cardPatterns) {
      if (cardPatterns[brand].test(firstSix)) {
        return brand;
      }
    }

    return "unknown";
  };

  const formatCardNumber = (number) => {
    const cleanNumber = number.replace(/\s+/g, "");
    return cleanNumber.replace(/(.{4})(?=.)/g, "$1 ");
  };

  return (
    <>
      {cards?.map((card) => {
        return (
            <div
            className={`card-payment-method ${
              card.active ? "card-payment-method-selected" : ""
            } border rounded d-flex justify-content-start align-items-center p-3 my-2`}
            onClick={() => !loading && handleSelectCard(card)}
            style={{
              pointerEvents: loading ? "none" : "auto",
              opacity: loading ? 0.6 : 1,
            }}
          >
            <RadioButton
              name="card"
              value={"card"}
              onChange={(e) => !loading && handleSelectCard(card)}
              checked={card.active}
              disabled={loading}
            />
            <i
              className={`${
                cardBrandIcon[
                  getCardBrandByDigits(
                    card.first_six_digits,
                    card.last_four_digits
                  )
                ] || "fa-regular fa-credit-card"
              } mx-3`}
            ></i>
            <h5 className="mt-2">
              {formatCardNumber(
                `${card.first_six_digits}******${card.last_four_digits}`
              )}
            </h5>
          </div>
        );
      })}
    </>
  );
};

export default UserCards;
